<div *ngIf="searchParams" class="mct-gap-54 mct-grid mct-grid-lt-md mct-cols-auto-lt-md sales-opp-search-grid">
  <div class="area-left">
    <div class="mb-27">
      <label class="light-text">{{ 'sales-opportunities.search.assigned-to' | translate | ucfirst }}</label>
      <p-select
        placeholder="{{ 'sales-opportunities.search.all' | translate | uppercase }}"
        appendTo="body"
        [(ngModel)]="searchParams.AssignedTo"
        [options]="assignedToUserItems"
        [style]="{ width: '100%', height: '36px' }"
        showClear
      ></p-select>
    </div>

    <div class="mb-27">
      <label class="light-text">{{ 'sales-opportunities.search.probability' | translate | ucfirst }}</label>
      <p-select
        placeholder="{{ 'sales-opportunities.search.all' | translate | uppercase }}"
        appendTo="body"
        [(ngModel)]="searchParams.Probability"
        [options]="probabilityItems"
        [style]="{ width: '100%', height: '36px' }"
        showClear
      ></p-select>
    </div>

    <div>
      <label class="light-text">{{ 'sales-opportunities.search.estimated-close-date' | translate | ucfirst }}</label>
      <wl-date-search-expression [expression]="searchParams.EstimatedCloseDateSearchExpression"></wl-date-search-expression>
    </div>
  </div>

  <div class="area-right">
    <div class="mb-27 atlas-autocomplete">
      <label class="light-text">{{ 'sales-opportunities.search.revenue-item' | translate | ucfirst }}</label>
      <p-autocomplete
        #autoComplete
        appendTo="body"
        optionLabel="ItemName"
        [(ngModel)]="selectedRevenueItems"
        [multiple]="true"
        [suggestions]="revenueItemSearchResults"
        (completeMethod)="searchRevenueItems($event)"
        (onSelect)="syncItems()"
        (onUnselect)="syncItems()"
      >
      </p-autocomplete>
    </div>
    <div class="mct-flex mct-col mct-gap-27">
      <div>
        <p-checkbox binary="true" [(ngModel)]="includeClosed" (onChange)="syncCheckboxes()" inputId="includeClosed"> </p-checkbox>
        <label for="includeClosed">
          {{ 'sales-opportunities.search.include-closed' | translate | ucfirst }}
        </label>
      </div>
      <div>
        <p-checkbox binary="true" [(ngModel)]="includeLost" (onChange)="syncCheckboxes()" inputId="includeLost"> </p-checkbox>
        <label for="includeLost">
          {{ 'sales-opportunities.search.include-lost' | translate | ucfirst }}
        </label>
      </div>
    </div>
  </div>
</div>
